import React,{useEffect,useState}from'react';
import{getRepeatingFields}from'../utils/repeatingFields';
import'./repeating-fields.css';

function RepeatingFieldsInput({question,value,onChange,invalid}){
  const fields=getRepeatingFields(question);
  const initialRows=Array.isArray(value)&&value.length>0?value:[{}];
  const[rows,setRows]=useState(initialRows);

  useEffect(()=>{
    setRows(initialRows);
  },[value,question.id]);

  const updateCell=(rowIndex,fieldId,fieldValue)=>{
    const next=rows.map((row,index)=>(
      index===rowIndex?{...row,[fieldId]:fieldValue}:row
    ));
    setRows(next);
    onChange(next);
  };

  const addRow=()=>{
    const next=[...rows,{}];
    setRows(next);
    onChange(next);
  };

  const removeRow=(rowIndex)=>{
    if(rows.length===1)return;
    const next=rows.filter((_,index)=>index!==rowIndex);
    setRows(next);
    onChange(next);
  };

  const renderInput=(field,row,rowIndex)=>{
    const options=field.options||[];
    const common={
      value:row[field.id]||'',
      onChange:event=>updateCell(rowIndex,field.id,event.target.value),
      placeholder:`Enter ${field.label.toLowerCase()}`,
      'aria-label':`${field.label}, entry ${rowIndex+1}`
    };

    if(field.type==='Long text'){
      return <textarea {...common} rows="2"/>;
    }

    if(['Single select','Dropdown','Yes / No'].includes(field.type)){
      const choices=field.type==='Yes / No'?['Yes','No']:options;
      return <select {...common}>
        <option value="">Select an answer</option>
        {choices.map(option=><option key={option}>{option}</option>)}
      </select>;
    }

    return <input
      type={
        field.type==='Number'?'number':
        field.type==='Date'?'date':
        field.type==='Time'?'time':
        'text'
      }
      {...common}
    />;
  };

  return <div
    className="form-field full repeating-fields-input"
    aria-invalid={invalid||undefined}
  >
    <span>{question.title} {question.required&&<b>*</b>}</span>
    <div className="repeating-table-wrap">
      <table className="repeating-table">
        <thead>
          <tr>
            <th scope="col">Entry</th>
            {fields.map(field=><th scope="col" key={field.id}>
              {field.label}{field.required&&<b>*</b>}
            </th>)}
            <th scope="col"><span className="sr-only">Remove</span></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row,rowIndex)=><tr key={`entry-${rowIndex}`}>
            <th scope="row">#{rowIndex+1}</th>
            {fields.map(field=><td key={field.id} data-label={field.label}>
              {renderInput(field,row,rowIndex)}
            </td>)}
            <td className="repeating-table-remove">
              {rows.length>1&&<button
                type="button"
                className="icon-btn danger"
                onClick={()=>removeRow(rowIndex)}
                aria-label={`Remove entry ${rowIndex+1}`}
              >
                Remove
              </button>}
            </td>
          </tr>)}
        </tbody>
      </table>
    </div>
    <button
      type="button"
      className="button secondary repeating-answer-add"
      onClick={addRow}
    >
      Add another entry
    </button>
  </div>;
}

export default RepeatingFieldsInput;